import { interpolateRgb } from 'd3-interpolate';
import { schemeAccent, schemeDark2 } from 'd3-scale-chromatic';

export const ALL_MAP_COLORS = schemeDark2.concat(schemeAccent);

export const colorInterpolatorForIndex = (index: number) =>
  interpolateRgb('white', ALL_MAP_COLORS[index % ALL_MAP_COLORS.length]);
